"use client";

import React from "react";
import { ExternalLink, Building2, Handshake, ArrowRight, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Separator } from "@/components/ui/separator";
const partners = [{
  id: 1,
  name: "Đại học Xây dựng Hà Nội",
  shortDesc: "Đối tác chiến lược toàn diện",
  fullDesc: "Trường Đại học Xây dựng Hà Nội (HUCE) là cơ sở đào tạo, nghiên cứu khoa học và chuyển giao công nghệ hàng đầu Việt Nam trong lĩnh vực xây dựng. Với bề dày lịch sử, HUCE cung cấp nguồn nhân lực chất lượng cao và các giải pháp kỹ thuật tiên tiến cho ngành.",
  affiliation: "NUCETECH được thành lập dựa trên nền tảng chuyên môn từ HUCE. Chúng tôi hợp tác chặt chẽ trong việc nghiên cứu, phát triển và ứng dụng các công nghệ mới vào thực tiễn thi công và quản lý dự án.",
  website: "https://huce.edu.vn",
  location: "Hà Nội, Việt Nam",
  coverSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/partner_huce_cover.png",
  coverSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/partner_huce_cover.png-wvc-srcset",
  coverSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/partner_huce_cover.png-wvc-sizes"
}, {
  id: 2,
  name: "Viện Khoa học Công nghệ Xây dựng",
  shortDesc: "Hợp tác nghiên cứu vật liệu",
  fullDesc: "Viện Khoa học Công nghệ Xây dựng (IBST) là tổ chức nghiên cứu khoa học và công nghệ hàng đầu trực thuộc Bộ Xây dựng, chuyên sâu về vật liệu xây dựng, kết cấu, và công nghệ thi công.",
  affiliation: "Cùng NUCETECH triển khai các đề tài nghiên cứu cấp nhà nước về vật liệu xanh và kiểm định chất lượng công trình trọng điểm quốc gia.",
  website: "https://ibst.vn",
  location: "Hà Nội, Việt Nam",
  coverSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/partner_ibst_cover.png",
  coverSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/partner_ibst_cover.png-wvc-srcset",
  coverSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/partner_ibst_cover.png-wvc-sizes"
}, {
  id: 3,
  name: "Tập đoàn Xây dựng Hòa Bình",
  shortDesc: "Ứng dụng công nghệ thi công",
  fullDesc: "Hòa Bình là một trong những nhà thầu xây dựng tổng hợp hàng đầu tại Việt Nam, tham gia thi công nhiều dự án quy mô lớn, yêu cầu kỹ thuật và mỹ thuật cao.",
  affiliation: "NUCETECH cung cấp giải pháp tư vấn chuyển đổi số và ứng dụng BIM trong quản lý thi công cho các siêu dự án của Hòa Bình.",
  website: "https://hbcg.vn",
  location: "TP. Hồ Chí Minh, Việt Nam",
  coverSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/partner_hoabinh_cover.png",
  coverSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/partner_hoabinh_cover.png-wvc-srcset",
  coverSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/partner_hoabinh_cover.png-wvc-sizes"
}, {
  id: 4,
  name: "Coteccons",
  shortDesc: "Giải pháp chuyển đổi số",
  fullDesc: "Coteccons là công ty xây dựng hàng đầu Việt Nam, nổi tiếng với mô hình Design & Build và năng lực thi công các công trình siêu cao tầng, phức hợp.",
  affiliation: "Đối tác chiến lược trong việc thử nghiệm và áp dụng các công nghệ quản lý công trường thông minh do NUCETECH phát triển.",
  website: "https://coteccons.vn",
  location: "TP. Hồ Chí Minh, Việt Nam",
  coverSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/partner_coteccons_cover.png",
  coverSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/partner_coteccons_cover.png-wvc-srcset",
  coverSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/partner_coteccons_cover.png-wvc-sizes"
}, {
  id: 5,
  name: "Autodesk Việt Nam",
  shortDesc: "Đối tác công nghệ BIM",
  fullDesc: "Autodesk là tập đoàn đa quốc gia chuyên cung cấp phần mềm thiết kế 2D và 3D cho các ngành kiến trúc, kỹ thuật, xây dựng, sản xuất và truyền thông giải trí.",
  affiliation: "NUCETECH là đối tác đào tạo và tư vấn triển khai các giải pháp BIM của Autodesk cho các doanh nghiệp xây dựng tại Việt Nam.",
  website: "https://autodesk.com",
  location: "Toàn cầu",
  coverSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/partner_autodesk_cover.png",
  coverSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/partner_autodesk_cover.png-wvc-srcset",
  coverSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/partner_autodesk_cover.png-wvc-sizes"
}, {
  id: 6,
  name: "Bộ Xây dựng",
  shortDesc: "Tư vấn chính sách & tiêu chuẩn",
  fullDesc: "Cơ quan của Chính phủ thực hiện chức năng quản lý nhà nước về: Xây dựng; vật liệu xây dựng; nhà ở và công sở; kiến trúc, quy hoạch xây dựng đô thị, quy hoạch xây dựng nông thôn.",
  affiliation: "NUCETECH tham gia đóng góp ý kiến chuyên môn, xây dựng các tiêu chuẩn, quy chuẩn kỹ thuật quốc gia mới trong lĩnh vực xây dựng và chuyển đổi số.",
  website: "https://moc.gov.vn",
  location: "Hà Nội, Việt Nam",
  coverSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/partner_moc_cover.png",
  coverSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/partner_moc_cover.png-wvc-srcset",
  coverSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/partner_moc_cover.png-wvc-sizes"
}];
const partnerGalleries = [{
  partnerId: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_huce_1.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_huce_1.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_huce_1.png-wvc-sizes",
  alt: "Khuôn viên Đại học Xây dựng"
}, {
  partnerId: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_huce_2.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_huce_2.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_huce_2.png-wvc-sizes",
  alt: "Phòng thí nghiệm công nghệ cao"
}, {
  partnerId: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_huce_3.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_huce_3.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_huce_3.png-wvc-sizes",
  alt: "Hội thảo khoa học quốc tế"
}, {
  partnerId: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_ibst_1.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_ibst_1.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_ibst_1.png-wvc-sizes",
  alt: "Trung tâm kiểm định IBST"
}, {
  partnerId: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_ibst_2.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_ibst_2.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_ibst_2.png-wvc-sizes",
  alt: "Thử nghiệm vật liệu mới"
}, {
  partnerId: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_hoabinh_1.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_hoabinh_1.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_hoabinh_1.png-wvc-sizes",
  alt: "Dự án thi công tiêu biểu"
}, {
  partnerId: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_hoabinh_2.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_hoabinh_2.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_hoabinh_2.png-wvc-sizes",
  alt: "Ứng dụng công nghệ tại công trường"
}, {
  partnerId: 4,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_coteccons_1.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_coteccons_1.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_coteccons_1.png-wvc-sizes",
  alt: "Công trình siêu cao tầng"
}, {
  partnerId: 4,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_coteccons_2.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_coteccons_2.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_coteccons_2.png-wvc-sizes",
  alt: "Mô hình quản lý BIM"
}, {
  partnerId: 5,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_autodesk_1.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_autodesk_1.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_autodesk_1.png-wvc-sizes",
  alt: "Phần mềm thiết kế 3D"
}, {
  partnerId: 5,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_autodesk_2.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_autodesk_2.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_autodesk_2.png-wvc-sizes",
  alt: "Đào tạo chuyển giao công nghệ"
}, {
  partnerId: 6,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_moc_1.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_moc_1.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_moc_1.png-wvc-sizes",
  alt: "Hội nghị triển khai chính sách"
}, {
  partnerId: 6,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_moc_2.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_moc_2.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_moc_2.png-wvc-sizes",
  alt: "Ban hành tiêu chuẩn xây dựng"
}];
export default function AffiliatePartners() {
  return <section id="affiliatepartners" className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 md:mb-16 max-w-3xl">
          <Badge variant="outline" className="mb-4 border-primary text-primary">
            Mạng lưới hợp tác
          </Badge>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4 tracking-tight">
            Liên kết & Đối tác Chiến lược
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl">
            NUCETECH tự hào đồng hành cùng các tổ chức, doanh nghiệp và viện nghiên cứu hàng đầu, kiến tạo hệ sinh thái đổi mới sáng tạo bền vững cho ngành xây dựng Việt Nam.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
          {partners.map((partner, i) => <div data-index={i} key={partner.id} className="h-full">
              <Dialog>
                <DialogTrigger asChild>
                  <Card className="group relative h-full overflow-hidden cursor-pointer border-2 border-transparent hover:border-primary transition-all duration-500 hover:shadow-xl hover:shadow-primary/10 bg-secondary rounded-xl">
                    <AspectRatio ratio={3 / 4} className="w-full h-full">
                      <img src={partner.coverSrc} data-wvc-srcset={partner.coverSrcset} data-wvc-sizes={partner.coverSizes} alt={partner.name} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-110 opacity-80 group-hover:opacity-100" loading="lazy" />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/50 to-transparent transition-opacity duration-500" />
                      
                      <div className="absolute inset-0 p-5 flex flex-col justify-end">
                        <div className="transform transition-transform duration-300 translate-y-2 group-hover:translate-y-0">
                          <h3 className="font-default text-white font-bold text-lg leading-tight mb-2">
                            {partner.name}
                          </h3>
                          <p className="text-slate-300 text-sm line-clamp-2 mb-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300 delay-100">
                            {partner.shortDesc}
                          </p>
                          <div className="flex items-center text-primary font-medium text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 delay-200">
                            <span>Xem chi tiết</span>
                            <ArrowRight className="ml-2 size-4" />
                          </div>
                        </div>
                      </div>
                    </AspectRatio>
                  </Card>
                </DialogTrigger>

                <DialogContent className="w-[70vw] h-[80vh] p-0 overflow-hidden gap-0 bg-background border-border rounded-xl shadow-2xl" showCloseButton={false}>
                  {}
                  <div className="bg-primary text-primary-foreground p-6 md:p-8 flex flex-col md:flex-row md:items-center justify-between gap-4 relative">
                    <div className="z-10">
                      <DialogTitle className="font-default text-2xl md:text-3xl font-bold mb-2 text-primary-foreground">
                        {partner.name}
                      </DialogTitle>
                      <DialogDescription className="text-primary-foreground/80 flex items-center gap-2 text-sm md:text-base">
                        <MapPin className="size-4" />
                        {partner.location}
                      </DialogDescription>
                    </div>
                    <Button variant="secondary" size="sm" asChild className="w-fit z-10 shadow-md">
                      <Link to={partner.website} newTab>
                        <ExternalLink className="mr-2 size-4" />
                        Truy cập Website
                      </Link>
                    </Button>
                    
                    {}
                    <div className="absolute right-0 top-0 h-full w-1/2 bg-gradient-to-l from-black/20 to-transparent pointer-events-none" />
                  </div>

                  <ScrollArea className="max-h-[70vh] md:max-h-[600px]">
                    <div className="p-6 md:p-8">
                      {}
                      <div className="mb-10">
                        <Carousel opts={{
                      align: "start",
                      loop: true
                    }} className="w-full">
                          <CarouselContent>
                            {partnerGalleries.filter(g => g.partnerId === partner.id).map((gallery, index) => <CarouselItem key={index} data-index={index} className="md:basis-1/2 lg:basis-2/3">
                                  <div className="p-1">
                                    <Card className="overflow-hidden border-0 shadow-md rounded-lg">
                                      <AspectRatio ratio={16 / 9}>
                                        <img src={gallery.src} data-wvc-srcset={gallery.srcset} data-wvc-sizes={gallery.sizes} alt={gallery.alt} className="object-cover w-full h-full" loading="lazy" />
                                      </AspectRatio>
                                    </Card>
                                  </div>
                                </CarouselItem>)}
                          </CarouselContent>
                          <div className="flex justify-end gap-2 mt-4 pr-4">
                            <CarouselPrevious className="relative inset-0 translate-y-0 size-10 bg-background border-border hover:bg-accent hover:text-accent-foreground" />
                            <CarouselNext className="relative inset-0 translate-y-0 size-10 bg-background border-border hover:bg-accent hover:text-accent-foreground" />
                          </div>
                        </Carousel>
                      </div>

                      <div className="grid md:grid-cols-2 gap-8 md:gap-12">
                        {}
                        <div>
                          <div className="flex items-center gap-3 mb-4">
                            <div className="p-2 bg-primary/10 rounded-lg text-primary">
                              <Building2 className="size-6" />
                            </div>
                            <h4 className="font-default text-xl font-semibold text-foreground">
                              Về Đối Tác
                            </h4>
                          </div>
                          <p className="text-muted-foreground leading-relaxed">
                            {partner.fullDesc}
                          </p>
                        </div>

                        {}
                        <div>
                          <div className="flex items-center gap-3 mb-4">
                            <div className="p-2 bg-primary/10 rounded-lg text-primary">
                              <Handshake className="size-6" />
                            </div>
                            <h4 className="font-default text-xl font-semibold text-foreground">
                              Hợp Tác Cùng NUCETECH
                            </h4>
                          </div>
                          <p className="text-muted-foreground leading-relaxed">
                            {partner.affiliation}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ScrollArea>
                  
                  {}
                  <div className="absolute top-4 right-4 z-50">
                     <DialogTrigger asChild>
                        <Button variant="ghost" size="icon" className="text-primary-foreground/70 hover:text-primary-foreground hover:bg-primary-foreground/20 rounded-lg">
                          <span className="sr-only">Đóng</span>
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="size-5"><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
                        </Button>
                     </DialogTrigger>
                  </div>
                </DialogContent>
              </Dialog>
            </div>)}
        </div>
      </div>
    </section>;
}